import {LangueType} from "./common.model";

export class EmprezMessage{

  id: number;
  eventDt: Date;
  lang = LangueType.FRANCAIS;
  url: string;
  description: string;
  active = false;




  _createSpecialElement(propertyName: string, data: any) {
    if ('lang' === propertyName) {
      this.lang = LangueType.retrieveFromCode(data);
      return true;
    }
    return false;
  }



}
